module.exports = __webpack_public_path__ + "img/1533872115.70f6e38a.jpg";